var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.625 2.5H16.375C17.5486 2.5 18.5 3.45139 18.5 4.625V17.375C18.5 18.5486 17.5486 19.5 16.375 19.5H3.625C2.4514 19.5 1.5 18.5486 1.5 17.375V4.625C1.5 3.4514 2.45139 2.5 3.625 2.5Z",
    stroke: "#0D0D0D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45165 5.8655C9.65014 5.37122 10.3499 5.37122 10.5483 5.8655L11.5428 8.34195C11.6273 8.55244 11.8249 8.69596 12.0512 8.71131L14.7137 8.89184C15.2452 8.92788 15.4614 9.59335 15.0526 9.93486L13.0047 11.6459C12.8306 11.7914 12.7552 12.0236 12.8105 12.2436L13.4616 14.8316C13.5916 15.3481 13.0255 15.7594 12.5744 15.4762L10.3142 14.0573C10.1221 13.9366 9.87791 13.9366 9.68581 14.0573L7.42564 15.4762C6.97453 15.7594 6.40845 15.3481 6.5384 14.8316L7.18947 12.2436C7.24481 12.0236 7.16935 11.7914 6.99529 11.6459L4.94735 9.93486C4.5386 9.59335 4.75483 8.92788 5.28625 8.89184L7.94881 8.71131C8.17511 8.69596 8.37265 8.55244 8.45718 8.34195L9.45165 5.8655Z",
    stroke: "#295EF1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 0.610352L5 4.61035",
    stroke: "#0D0D0D",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0.610352L15 4.61035",
    stroke: "#0D0D0D",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEvents);
export default __webpack_public_path__ + "static/media/icon-events.8329de2de1f7c70c0a2466f81f2f00bc.svg";
export { ForwardRef as ReactComponent };